var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "white",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.45455 8.818C7.90642 8.818 8.27274 8.45169 8.27274 7.99982C8.27274 7.54795 7.90642 7.18164 7.45455 7.18164C7.00267 7.18164 6.63635 7.54795 6.63635 7.99982C6.63635 8.45169 7.00267 8.818 7.45455 8.818Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75003 13.7499C9.75003 11.8009 11.152 10.1754 13.0001 9.82295V6.49998C13.0001 5.67299 12.327 5 11.5 5H6.50001C5.673 5 5 5.67299 5 6.49998V13.4999C5 14.3269 5.673 14.9999 6.50001 14.9999H9.95303C9.82303 14.6059 9.75003 14.1869 9.75003 13.7499ZM7.37002 11.0899C7.04001 10.7599 6.46001 10.7599 6.13001 11.0899L6.00001 11.2194V6.49998C6.00001 6.22399 6.22401 5.99999 6.50001 5.99999H11.5C11.776 5.99999 12 6.22399 12 6.49998V9.71945L11.62 9.33945C11.278 8.99746 10.7215 8.99746 10.38 9.33945L8.00002 11.7194L7.37002 11.0899Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.048 11.452C15.434 10.8385 14.618 10.5 13.75 10.5C12.882 10.5 12.066 10.8385 11.452 11.452C10.838 12.0655 10.5 12.882 10.5 13.75C10.5 14.618 10.8385 15.4339 11.452 16.0479C12.0655 16.6619 12.882 16.9999 13.75 16.9999C14.618 16.9999 15.434 16.6619 16.048 16.0479C16.662 15.4339 17 14.618 17 13.75C17 12.882 16.6615 12.066 16.048 11.452ZM15.253 13.2025L13.628 15.0775C13.537 15.1819 13.407 15.2444 13.268 15.2494C13.2615 15.2499 13.256 15.2499 13.25 15.2499C13.1175 15.2499 12.99 15.1974 12.8965 15.1035L12.0215 14.2285C11.826 14.033 11.826 13.717 12.0215 13.5215C12.217 13.326 12.533 13.326 12.7285 13.5215L13.2235 14.0165L14.497 12.5475C14.6785 12.339 14.994 12.317 15.2025 12.497C15.411 12.678 15.4335 12.9935 15.253 13.2025Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified2);
export default __webpack_public_path__ + "static/media/verified2.202a2355e0492657ec5724f8ca9d19b7.svg";
export { ForwardRef as ReactComponent };